import Panel, { variants as panelVariants, type PanelProps } from './panel';

export { Panel, PanelProps, panelVariants };
export default Panel;
